import axios from 'axios';
import { host } from './API_Routes';

const instance = axios.create({
    baseURL: host
})
const axiosPrivate = axios.create({
    baseURL: host,
    headers: { 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
    withCredentials: true
});

export { instance, axiosPrivate }